import { Tabs as MuiTabs } from '@material-ui/core'
import styled from 'styled-components'
import theme from '../theme'

const Tabs = styled(MuiTabs)`
  .MuiTabs-flexContainer:after {
    content: '';
    flex: 1;
    border-bottom: 3px solid ${theme.palette.divider};
  }

  .MuiTabs-indicator {
    background-color: ${theme.palette.primary.main};
  }
`

export default Tabs
